const VERSION = 'v1';
export const CURRENT_INDEX = 'current_ahv_index';
const tokenKey = "".concat(VERSION, "_token");
export const setToken = token => sessionStorage.setItem(tokenKey, token);
export const getToken = () => {
  var _sessionStorage$getIt;
  return (_sessionStorage$getIt = sessionStorage.getItem(tokenKey)) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : '';
};
const getKey = token => {
  return "".concat(VERSION, "_").concat(CURRENT_INDEX, "_").concat(token);
};
export const setCurrentIndex = (currentIndex, token) => {
  sessionStorage.setItem(getKey(token), currentIndex.toString());
};
export const getCurrentIndex = token => {
  var _sessionStorage;
  const index = (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem(getKey(token));
  if (index) return Number(index);
  return -1;
};
const removeKey = key => {
  sessionStorage.removeItem(key);
};
export const removeAllValuesContainingAhvIndexTextAndNotOtherValues = token => {
  Object.keys(sessionStorage).forEach(key => {
    if (key.includes(CURRENT_INDEX)) {
      if (key !== getKey(token)) {
        removeKey(key);
      }
      if (Number.isNaN(Number(sessionStorage[key]))) {
        removeKey(key);
      }
    }
  });
};
export const removeCurrentIndex = token => {
  removeKey(getKey(token));
};